<template>
  <div class="tools-panel">
    <vs-divider position="left">When</vs-divider>
    <section class="timeline">
      <range-slider
        :id="'dataHubSlider'"
        :range-data="timelineData"
        :theme="'msp'"
        @change="updateActiveMomentId"
      ></range-slider>
    </section>
    <div v-show="activeMomentId === moments.past.id" id="past-tools">
      <vs-divider position="left">Tool</vs-divider>
      <div class="inner-container">
        <ul class="radio-opts label">
          <li>
            <vs-radio v-model="activeTool" color="#19535F" :vs-value="bioTool"
              >Biological Suitability Tool</vs-radio
            >
          </li>
          <li>
            <vs-radio v-model="activeTool" color="#19535F" :vs-value="waveTool"
              >Wave Energy Suitability Tool</vs-radio
            >
          </li>
          <li>
            <vs-radio v-model="activeTool" color="#19535F" :vs-value="windTool"
              >Wind Energy Suitability Tool</vs-radio
            >
          </li>
        </ul>
      </div>
      <section v-if="activeTool === bioTool">
        <tool-bio-form></tool-bio-form>
      </section>
      <section v-if="activeTool === waveTool">
        <tool-wave-energy-form></tool-wave-energy-form>
      </section>
      <section v-if="activeTool === windTool">
        <tool-wind-energy-form></tool-wind-energy-form>
      </section>
    </div>
  </div>
</template>
<script>
import RangeSlider from "@/components/ui/RangeSlider";
import ToolBiologicalForm from "@/components/ToolBiologicalForm";
import ToolWaveEnergyForm from "@/components/ToolWaveEnergyForm";
import ToolWindEnergyForm from "@/components/ToolWindEnergyForm";
import { MOMENTS, TIMELINE_MOMENTS, BTM_TOOLS } from "@/constants.js";
import { mapActions } from "vuex";

export default {
  components: {
    "range-slider": RangeSlider,
    "tool-bio-form": ToolBiologicalForm,
    "tool-wave-energy-form": ToolWaveEnergyForm,
    "tool-wind-energy-form": ToolWindEnergyForm
  },
  data() {
    return {
      activeTool: "bio",
      activeMomentId: TIMELINE_MOMENTS[0].id,
      timelineData: TIMELINE_MOMENTS,
      moments: MOMENTS,
      bioTool: BTM_TOOLS.BIOLOGICAL_SUITABILITY,
      waveTool: BTM_TOOLS.WAVE_ENERGY_SUITABILITY,
      windTool: BTM_TOOLS.WIND_ENERGY_SUITABILITY
    };
  },
  watch: {
    activeTool() {
      this.setBTMToolsActiveTool(this.activeTool);
    }
  },
  methods: {
    ...mapActions({
      setBTMToolsActiveTool: "setBTMToolsActiveTool"
    }),
    updateActiveMomentId(id) {
      this.activeMomentId = id;
    }
  }
};
</script>
<style scoped>
.inner-container {
  display: flex;
  flex-grow: 1;
  justify-content: flex-start;
  align-items: center;
}
.tools-panel {
  flex: 1;
  margin-left: 20px;
  margin-right: 20px;
  font-size: 0.8rem;
}
.radio-opts {
  flex-direction: row;
  display: flex;
  justify-content: space-evenly;
  flex-grow: 1;
  flex-wrap: wrap;
}

.radio-opts li {
  padding: 10px;
  margin-left: 10px;
  border-radius: 5px;
  list-style: none;
}
</style>
